import styled from 'styled-components';

export const InterviewFormWrapper = styled.div`
  & > div:nth-child(2) {
    margin: 24px 0;
  }
`;
